import { PairedSalesAnalysisFeature } from '@aloft/toolkit-shared';

export type PairedSalesSqFtFeature = Extract<
  PairedSalesAnalysisFeature,
  'grossLivingArea' | 'totalBasementArea' | 'site'
>;

export function isPairedSalesSqFtFeature(x: unknown): x is PairedSalesSqFtFeature {
  if (typeof x !== 'string') return false;
  return x === 'grossLivingArea' || x === 'totalBasementArea' || x === 'site';
}
